<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-28 19:04:17
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\ApprovalProcess\viewCustomFormApprovalProcess.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-08 10:59:25
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_approvalProcess_form_customFormTitle')"
    backgroundClass="transparent"
    widthClass="max-1000"
    pad="0"
  >
    <template v-slot:nav-actions>
      <approvalTools
        v-if="Data && Data['flow_status'] == 1"
        :curUuid="Data['uuid']"
        :staff_uuid="curStaff"
        :flag="Data['cancel_flag']"
        :data_type="Data['data_type']"
        :final_node="Number(Data['is_final_task_node'])"
        :matched="Number(Data['is_match']) ? true : false"
        :canRevoke="Number(Data['is_allow_revoke'])"
        :canRollback="Number(Data['is_allow_rollback'])"
        :canForward="Number(Data['is_allow_forward'])"
        @back="onBack"
        @forward="onForward"
        @approval="onApproval"
        @reject="onReject"
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <noContent v-if="!Data" />
      <ApprovalTriger
        v-if="Data"
        :bg-color="Data.approval_bg_color"
        :slide-color="Data.approval_tint_color"
        @triger="
          $toPage(
            '/admin/approval-process/custom-form-detail/' +
              $route.params.params +
              '/approval-detail/' +
              $route.params.params
          )
        "
      >
        <template v-slot:time>
          {{ $getDateTime(Data.operate_utc_datetime, "YYYY/MM/DD HH:mm") }}
        </template>
        <template v-slot:status>
          {{ $getCommonLangValue(Data.status_detail) }}
        </template>
      </ApprovalTriger>

      <Section v-if="Data">
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_swiftNumberLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              v-model="Data.swift_number"
              :label="$t('label_essweb_leaveApplication_form_swiftNumberLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_submitDateLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="
                $getDateTime(Data.submission_utc_datetime, 'YYYY/MM/DD HH:mm')
              "
              :label="$t('label_essweb_leaveApplication_form_submitDateLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              label="label_essweb_leaveApplication_form_applicantLabel"
              v-model="user"
              readonly
              chips
              avatar
              small-chips
              two-line
              :items="users"
              item-value="uuid"
              item-text="preferred_name"
            >
              <template v-slot:selection.avatar="{ data }">
                <StaffAvatar
                  :src="data.item.staff_avatar"
                  left
                  small
                  :isTemp="data.item.is_temp"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:selection="{ data }">
                {{ $getCommonLangValue(data.item.preferred_name) }}
              </template>
            </AutoComplete>
          </v-col>
        </v-row>
      </Section>
      <Section
        v-if="Data && Data['ess_common_application_type_custom_field_value']"
      >
        <v-form
          ref="form"
          lazy-validation
          v-if="
            Data['ess_common_application_type_custom_field_value'].length > 1
          "
        >
          <v-row>
            <DynamicForm
              :data="item"
              v-for="(item, index) in Data[
                'ess_common_application_type_custom_field_value'
              ]"
              :key="`formitem--${index}`"
              :iSEdited="iSEdited"
              @change="
                (uuid, value, change) => {
                  item['_value'] = value;
                  item['is_changed'] = !change;
                }
              "
            />
          </v-row>
        </v-form>
        <v-row v-else>
          <DynamicForm
            :data="item"
            :iSEdited="iSEdited"
            v-for="(item, index) in Data[
              'ess_common_application_type_custom_field_value'
            ]"
            :key="`formitem--${index}`"
            @change="
              (uuid, value, change) => {
                item['_value'] = value;
                item['is_changed'] = !change;
              }
            "
          />
        </v-row>
      </Section>
    </template>
    <template v-slot:tools-main> </template>
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        submitBtn
        @submit="toSave"
        @cancel="toBack"
      />
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import approvalTools from "@/Page/EssAdmin/Approval/ApprovalProcess/components/approvalTools";
export default {
  name: "viewCustomFormApprovalProcess",
  components: { approvalTools },
  computed: {
    ...mapGetters(["AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
  },
  data() {
    return {
      page_params: {
        flow_status: 0,
      },
      needSender: false,
      isOnlineChange: false,
      Data: null,
      iSEdited: false,
      can_be_cancel: false,
      users: [],
      showSender: false,
      reason: "",
      curStaff: null,
      user: null,
    };
  },
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.params)); //解密参数
    this.curStaff = this.curAppInfo["user"]["user_id"];
    this.getDetail();
  },
  watch: {},
  filters: {
    getDuration(obj, calback) {
      return calback(obj);
    },
  },
  methods: {
    toBack: function () {
      if (this.iSEdited) {
        this.iSEdited = false;
        this.getDetail();
      } else {
        this.$router.back();
      }
    },
    onInputImage: function (image) {
      this.Data.attachments = image;
    },
    getDuration(obj) {
      let day = Number(obj["number_of_day"] || 0);
      let minutes = Number(obj["number_of_minutes"] || 0);
      var str = "";
      if (minutes == 0 && day == 0) {
        str =
          day +
          this.$t("label_essweb_system_dayLabel") +
          0 +
          this.$t("label_essweb_system_hourLabel") +
          minutes +
          this.$t("label_essweb_system_minutesLabel");
      }
      if (day > 0) {
        str += day + this.$t("label_essweb_system_dayLabel");
      }

      if (minutes > 0 && minutes < 60) {
        str += minutes + this.$t("label_essweb_system_minutesLabel");
      }
      if (minutes > 0 && minutes > 60) {
        str +=
          Math.floor(minutes / 60) +
          this.$t("label_essweb_system_hourLabel") +
          (minutes % 60) +
          this.$t("label_essweb_system_minutesLabel");
      }
      return str;
    },

    toDelete: function (sender) {
      const that = this;
      if (!this.needSender) {
        that.onDelete(null);
      } else {
        if (sender) {
          that.onDelete(sender);
        } else {
          this.showSender = true;
        }
      }
    },
    onDelete: function (sender) {
      const that = this;
      // if (!sender || sender.length <= 0) {
      //   this.$showMessage({
      //     title: this.$t(
      //       "message_essweb_form_isMustSelectApproval_noSelectLabel"
      //     ),
      //     okText: this.$t(
      //       "message_essweb_form_isMustSelectApproval_toSelectBtnLabel"
      //     ),
      //     text: this.$t("message_essweb_form_isMustSelectApprovalLabel"),
      //     type: "warning",
      //   });
      //   return false;
      // }
      let data = {
        uuid: this.page_params.id,
        data_type: this.page_params.data_type,
        business_action: "cancel",
      };
      //解决重复宋版人bug
      // if (sender.length > 1) {
      //   if (sender[0] == sender[1]) sender = [sender[0]];
      // }
      // if (sender) data["sender_uuid"] = sender.join(",");
      this.$Request({
        method: "POST",
        table: "x",
        url: "/approval/push/",
        data: data,
      }).then((res) => {
        that.$toBack();
      });
    },
    onReject: function (comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 6,
          business_action: "terminate",
          cancel_flag: this.Data.cancel_flag,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_reject_rejectSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onApproval: function (comments = "", sender) {
      const that = this;
      let data = {
        uuid: this.page_params.id,
        data_type: 6,
        business_action: "send",
        cancel_flag: this.Data.cancel_flag,
        operate_comment: comments,
      };
      if (sender.length != 0) data["sender_uuid"] = sender.join(",");
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: data,
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_send_approvalSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onForward: function (sender, node, comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 6,
          business_action: "forward",
          cancel_flag: this.Data.cancel_flag,
          sender_uuid: sender,
          business_action_status: node == 0 ? 4 : 3,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_forward_forwardSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onBack: function (sender, comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 6,
          cancel_flag: this.Data.cancel_flag,
          business_action: "back",
          business_action_status: sender == 0 ? 1 : 2,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_back_backSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    toSave() {
      const that = this;
      let arr = [];
      if (this.Data["attachments"])
        this.Data["attachments"].map((ite) => {
          arr.push(ite.uuid);
        });
      that
        .$Request({
          method: "POST",
          table: "ess_lv_leave_application_record",
          url: "/leave/update-leave-table/",
          data: {
            uuid: this.page_params.id,
            attachment_uuid: arr.join(","),
          },
        })
        .then((res) => {
          if (that.Data["attachments"]) {
            that.isOnlineChange = Math.random() * 9999999;
          }
          that.getDetail();
        });
    },
    getDetail: function () {
      const that = this;
      that.iSEdited = false;
      // that.Data = null;
      this.$Request({
        method: "POST",
        table: "ess_common_application_record",
        url: "/approval-task/get-approval-task-details/",
        data: {
          uuid: this.page_params.id,
          data_type: 6,
          is_approval: 1,
        },
      }).then((res) => {
        that.user = res.data.uuid;
        that.can_be_cancel = Number(res.data["can_it_be_cancelled"]);
        if (res.data["ess_common_application_type_custom_field_value"])
          res.data["ess_common_application_type_custom_field_value"].map(
            (item) => {
              item["is_changed"] = false;
              item["_value_init"] = that.$defaultInitValue(
                item.custom_field_data_type
                  ? item.custom_field_data_type
                  : "string",
                item.custom_field_value
              );
              item["_value"] = that.$defaultInitValue(
                item.custom_field_data_type
                  ? item.custom_field_data_type
                  : "string",
                item.custom_field_value
              );
              item["_uuid"] = item.uuid;
            }
          );
        if (res.data.agent_staff)
          that.users = [
            {
              staff_avatar: res.data.agent_staff.staff_avatar,
              uuid: res.data.uuid,
              preferred_name: res.data.agent_staff.preferred_name,
            },
          ];
        that.Data = res.data;
      });
    },
  },
};
</script>
